module.exports = __webpack_public_path__ + "static/type-brigade-50-glasfurdandwalker-1-f7e963275583e80653ce3bb7befdfe63.jpg";